module.exports = __webpack_public_path__ + "img/wheel.48fbc381.png";